export const fileInputToArray = (files) => Array.from(files);
export const appendFiles = (formData, key, files) => {
    for (const file of fileInputToArray(files)) {
        formData.append(key, file);
    }
};
export const buildFilesFormData = (key, files) => {
    const formData = new FormData();
    appendFiles(formData, key, files);
    return formData;
};
